import React from "react";
import {Button} from "reactstrap";
import TextField from "@material-ui/core/TextField";
import {Grid} from "@mui/material";


// noinspection JSUnresolvedVariable
/**
 * @param {Davidsons_Products_Properties} product
 * @param itemKey
 * @param remove
 * @param update
 * @param updateQ
 */
export default ({product, itemKey, remove, update, updateQ}) => (
	<div
		key={itemKey}
		className="form-group"
		style={{
			backgroundColor: "#f9f9f9",
			padding:"5px",
			marginBottom: "8px",
			fontSize: "14px",
			borderRadius: "3px !important",
			border: "1px solid #efefef",
		}}
	>
		<Grid
				style={{padding: "5px"}}
				container
		      direction="row"
		      justifyContent="space-between"
		      alignItems="center"
				>
			<Grid
				style={{width: "3.5rem"}}
				item>

				{product.item}
			</Grid>
			<Grid item>
			<Button style={{marginRight: "10px"}} color=" btn-default default"
			                             onClick={() => update(product.pkey, product.item, (parseInt(product.item_quantity) - 1))}
			                             size={"sm"}>
				<i
				className={"fa fa-caret-left"}/></Button>
			<TextField
				value={product.item_quantity}
				// inventory={}
				pkey={product.pkey}
				style={{
					width: "50px",
					textAlignLast: "center"
				}}
				onChange={updateQ(itemKey, product.item, product.pkey)}
				margin="none"
				fullWidth={false}
			/>
			<Button style={{marginLeft: "10px"}} color=" btn-default default"
			        onClick={() => update(product.pkey, product.item, (parseInt(product.item_quantity) + 1))}
			        size={"sm"}><i className={"fa fa-caret-right"}/></Button>
			</Grid>
		<Grid item>
			<Button
			id={product.item}
			// binary_id={product.binary_id}
			color={"danger"}
			size={"sm"}
			style={{lineHeight: "1.4", marginRight: "1px", marginTop: "-3px"}}
			className={"pull-right"}
			onClick={remove}
		>
			<i className={"fa fa-times"}/>
		</Button>
		</Grid>
		</Grid>
	</div>
);
